<mat-form-field class="country-code no-hint prefix-field" appearance="outline" [ngClass]="{'mobile-flex': layout === 'mobile-friendly'}">
  <mat-label>{{ 'general.api_phone_country_code' | translate }}</mat-label>
  <mat-select [panelClass]="'overlay-match-input'" [disabled]="disabled" [(ngModel)]="countryCode" [ngModelOptions]="{standalone: true}">
    <mat-option>
      <app-select-search [values]="regionCodes" [filterBy]="['region', 'code']" (filteredValues)="regionCodesFiltered.next(convert($event.slice()))"></app-select-search>
    </mat-option>
    <mat-option [value]="null">-</mat-option>
    <mat-option *ngFor="let regionCode of regionCodesFiltered | async" [value]="regionCode.code">
      <span class="region">{{ regionCode.region }}</span> {{ '+' + regionCode.code }}
    </mat-option>
    <mat-option *ngFor="let regionCode of regionCodes" [value]="regionCode.code" class="hide" disabled>
      <span class="region">{{ regionCode.region }}</span> {{ '+' + regionCode.code }}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field appearance="outline" class="phone-nr with-prefix responsive-hint"
                [ngClass]="{'mobile-flex': layout === 'mobile-friendly', 'field-error': !isNumberValid, 'no-hint': isNumberValid}">
  <mat-label>{{ label | translate }}</mat-label>
  <input matInput type="tel" name="phoneNr" [(ngModel)]="number" [disabled]="disabled" autocomplete="off">
  <mat-hint *ngIf="!isNumberValid" class="text-warning">
    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
    {{ (!isLengthValid ? 'general.api_phone_number_too_long' : 'general.api_validation_only_digits') | translate }}
  </mat-hint>
</mat-form-field>
